// 포인터는 오래된 사건일 수 있다. 종류만 보고 최신의 다른 제안에 응답하지 않는다.
export function inboxDecision(pointer, pack) {
  if (!pointer?.entityId || pointer.taskId !== pack?.task?.taskId) return { kind: 'unavailable' };
  const id = pointer.entityId;
  if (pointer.entityType === 'question') {
    const question = pack.questions?.find((item) => item.questionId === id);
    if (question) return { kind: 'question', question };
  }
  if (pointer.entityType === 'proposal') {
    const proposal = pack.openProposals?.find((item) => item.proposalId === id);
    if (proposal) return { kind: 'proposal', proposal };
    if (pack.currentVersion?.promotedFromProposalId === id) {
      return { kind: 'promoted', version: pack.currentVersion };
    }
    if (pack.supersededProposals?.some((item) => item.proposalId === id)) return { kind: 'superseded' };
  }
  if (pointer.entityType === 'handoff') {
    const handoff = pack.handoffs?.find((item) => item.handoffId === id);
    if (handoff) return { kind: 'handoff', handoff };
  }
  return { kind: 'unavailable' };
}
